import { AUTH_LOGOUT } from '@/store/auth/types';
import store from '../store/store';

export class Http {
  static HEADERS = {
    'Content-Type': 'application/json',
    // heroku app cors workaround
    // Authorization: 'Token MTAxOTkwfGBoZ18tMEZlXjwrUDhfait3RUpPRVhjSyVOZ2BBMDs2',
    // 'X-Requested-With': 'XMLHttpRequest',
  };

  static abortController = new AbortController();

  static async get(url) {
    try {
      return await request(url, 'GET');
    } catch (e) {
      throw new Error(e.message);
    }
  }

  static async post(url, data = {}) {
    try {
      return await request(url, 'POST', data);
    } catch (e) {
      throw new Error(e.message);
    }
  }

  static async delete(url, data = {}) {
    try {
      return await request(url, 'DELETE', data);
    } catch (e) {
      throw new Error(e.message);
    }
  }

  static async put(url, data) {
    try {
      return await request(url, 'PUT', data);
    } catch (e) {
      throw new Error(e.message);
    }
  }

  static async patch(url, data = {}) {
    try {
      return await request(url, 'PATCH', data);
    } catch (e) {
      throw new Error(e.message);
    }
  }

  static abortRequest() {
    Http.abortController.abort();
    Http.abortController = new AbortController();
  }
}

async function request(url, method = 'GET', data, paramsData) {
  try {
    const { signal } = Http.abortController;
    const config = {
      method,
      headers: Http.HEADERS,
      signal,
    };

    if (method === 'PUT') {
      config.params = paramsData;
      config.body = JSON.stringify(data);
    }

    if (method === 'POST' || method === 'PATCH' || method === 'DELETE') {
      config.body = JSON.stringify(data);
    }
    const urlPrefix = '/app/api';
    const response = await fetch(`${urlPrefix}${url.includes('v2') ? url : `/v1${url}`}`, config);

    if (response.status === 401) {
      store.dispatch(AUTH_LOGOUT);
    }
    if (response.ok) {
      try {
        return await response.json();
      } catch {
        return 'empty response';
      }
    }
    const error = await response.json();
    throw new Error(error.error || error.phone);
  } catch (e) {
    const error = e.message;
    if (e.name === 'AbortError') {
      // eslint-disable-next-line no-console
      console.log('Aborted a request');
      return 'Aborted a request';
    }
    // eslint-disable-next-line no-console
    console.log('bad response: ', error);
    throw new Error(error);
  }
}
